export default __webpack_public_path__ + "static/media/spintax-black.33871d8f.svg";